import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { REPORT_FILTER_ACTION_TYPE } from "../../../../redux/actions-type";
import DateRangeModal from "../../../../globalComponents/Modals/DateRangeModal/DateRangeModal";
import { ReactComponent as SalesBox } from "../../../../assets/icons/report/salesBox.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/icons/report/arrow.svg";

import { useReportSalesCustomHook } from "./utils/utils";
import moment from "moment";
import "moment/locale/az";
import { WhereComingDropdown } from "../../../../globalComponents/GlobalHead/WhereComingDropdown/WhereComingDropdown";
import { SalesCoursesDropdown } from "../../../../globalComponents/GlobalHead/CoursesDropdown/SalesCoursesDropdown";

const SalesReport = () => {
  const [openCalendar, setOpenCalendar] = useState(false);

  const { consultationStatisticSelectedOption, selectedDateType } = useSelector(
    (state) => state.reportDateFilter
  );

  const { consultationStatistics } = useSelector((state) => state.reportDatas);

  const {
    getAllDataByMonth,
    getAllDataByDateRange,
    getAllDefaultData,
    date,
    setDate,
    selectDateTypeOption,
  } = useReportSalesCustomHook();

  useEffect(() => {
    getAllDefaultData();
  }, []);

  const data = [
    { key: 1, name: "Cari ay" },
    { key: 3, name: "Son 3 ay" },
    { key: 6, name: "Son 6 ay" },
    { key: 12, name: "İllik" },
    { key: "", name: "Tarix seç" },
  ];

  const dateTypeData = [
    {
      key: "applicationDate",
      label: "Müraciət tarixi",
    },
    {
      key: "lastContactDate",
      label: "Son əlaqə tarixi",
    },
  ];

  const dispatch = useDispatch();

  const applyFilter = (startDate = "", endDate = "") => {
    getAllDataByDateRange(startDate, endDate);
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_CONSULTATION_STATISTICS_CHOOSE_DATE_FILTER,
      payload: { financeChooseDate: { startDate, endDate } },
    });
    setDate({
      startDate,
      endDate,
    });
    setOpenCalendar(false);
  };

  const applyMonthFilter = (option) => {
    getAllDataByMonth(option.key);
    setOpenCalendar(false);
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_CONSULTATION_STATISTICS_MONTH_FILTER,

      payload: { consultationStatisticMonthFilter: option.key },
    });
  };

  const selectOption = (option) => {
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_CONSULTATION_STATISTICS_DATE_SELECTED_OPTION,
      payload: option,
    });
    if (option.name === "Tarix seç") {
      setOpenCalendar(!openCalendar);
    } else {
      applyMonthFilter(option);
    }
  };

  useEffect(() => {
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_CONSULTATION_STATISTICS_DATE_SELECTED_OPTION,
      payload: {
        key: 1,
        name: "Cari ay",
      },
    });
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_SELECTED_DATE_TYPE,
      payload: {
        key: "applicationDate",
        label: "Müraciət tarixi",
      },
    });
    return () => {
      dispatch({
        type: REPORT_FILTER_ACTION_TYPE.GET_CONSULTATION_STATISTICS_MONTH_FILTER,
        payload: { consultationStatisticMonthFilter: "" },
      });
    };
  }, []);

  const salesData = [
    {
      id: 1,
      name: "Daxil olan lead",
      count: consultationStatistics?.leadsCount,
      color: "orange",
    },
    {
      id: 2,
      name: "Danışılan lead",
      count: consultationStatistics?.spokenLeadsCount,
      color: "orange",
    },
    {
      id: 3,
      name: "Konsultasiya sayı",
      count: consultationStatistics?.consultationCount,
      color: "green",
    },
    {
      id: 4,
      name: "Qualified",
      count: consultationStatistics?.qualifiedCount,
      color: "green",
    },
    {
      id: 5,
      name: "Deal",
      count: consultationStatistics?.dealCount,
      color: "green",
    },
    {
      id: 6,
      name: "Unqualified",
      count: consultationStatistics?.unqualifiedCount,
      color: "red",
    },
    {
      id: 7,
      name: "Lost",
      count: consultationStatistics?.lostCount,
      color: "red",
    },
  ];

  return (
    <div className="lesson-remainder sales " style={{ height: "100%" }}>
      <div className="sales-divition-img">
        <SalesBox />
      </div>
      <h2>Satış hesabat</h2>
      <div className="students-remainder">
        <div className="finance-date-filter">
          {dateTypeData.map((item, index) => (
            <div
              key={index}
              onClick={() => selectDateTypeOption(item)}
              className={`content-box ${
                selectedDateType.key === item?.key ? "active" : ""
              }`}
            >
              {item.label}
            </div>
          ))}
        </div>
        <div className="finance-date-filter">
          {data.map((item, index) => (
            <div
              key={index}
              onClick={() => selectOption(item)}
              className={`content-box ${
                consultationStatisticSelectedOption?.key === item?.key
                  ? "active"
                  : ""
              }`}
            >
              {item.name}
            </div>
          ))}
        </div>

        {date.startDate && date.endDate && (
          <div style={{ textAlign: "center" }}>
            <span>{`${moment(date?.startDate)
              .locale("az")
              .format("DD MMMM YYYY")} - ${moment(date?.endDate)
              .locale("az")
              .format("DD MMMM YYYY")} `}</span>
          </div>
        )}

        <div className="sales-filter-container">
          <SalesCoursesDropdown
            deviceType="desktop"
            type="sales"
            selectedOption={consultationStatisticSelectedOption.key}
            date={date}
            selectedDateType={selectedDateType}
          />
          <WhereComingDropdown
            deviceType="desktop"
            type="sales"
            selectedOption={consultationStatisticSelectedOption.key}
            date={date}
            selectedDateType={selectedDateType}
          />
        </div>

        <div className="sales-report-cards">
          {salesData?.map((student) => (
            <div key={student.id} className="sales-report-card">
              <div
                className={`report-type left ${
                  student.color === "orange"
                    ? "orange"
                    : student.color === "green"
                    ? "green"
                    : student.color === "blue"
                    ? "blue"
                    : "red"
                } `}
              >
                <ArrowIcon />
                <h4>{student.name}</h4>
              </div>
              <div
                className={`report-type right ${
                  student.color === "orange"
                    ? "orange"
                    : student.color === "green"
                    ? "green"
                    : student.color === "blue"
                    ? "blue"
                    : "red"
                } `}
              >
                <h4>{student.count} </h4>
              </div>
            </div>
          ))}
        </div>
      </div>
      {openCalendar && (
        <DateRangeModal
          applyFilter={applyFilter}
          setOpenCalendar={setOpenCalendar}
        />
      )}
    </div>
  );
};

export default SalesReport;
